import produce from 'immer';

// TYPES
import { Types, ExcluirMensagemErro } from './types';
import { ReducerAction } from '../../../../../../types';

export const INITIAL_STATE: ExcluirMensagemErro = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ExcluirMensagemErro {
	return produce(state, draft => {
		switch (action.type) {
			case Types.EXCLUIR_MENSAGEM_ERRO_REQUEST: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			case Types.EXCLUIR_MENSAGEM_ERRO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.EXCLUIR_MENSAGEM_ERRO_FAILURE: {
				draft.status = 400;
				break;
			}

			case Types.EXCLUIR_MENSAGEM_ERRO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
	});
}
